import { DocumentDetailFilterRequest } from '@mercator-gcp/types/elastic_search_service/documents/DocumentDetailFilterRequest';
import { DocumentDetailFilterResponse } from '@mercator-gcp/types/elastic_search_service/documents/DocumentDetailFilterResponse';
import { useQuery } from 'react-query';
import ElasticSearchFilterAPI from 'services/API/ElasticSearchFilterAPI';

type Props = DocumentDetailFilterRequest & {
  page: number;
  point?: [number, number] | null;
  radius?: number | null;
};

export const useDocumentSearch = ({
  page = 1,
  document_type_codes,
  state_code,
  city_id,
  city_ids,
  city_code,
  allowed_city_ids,
  mercator_metropolitan_id,
  mercator_metropolitan_ids,
  latest_status,
  keyword_inclusions,
  keyword_exclusions,
  vertical_id_inclusions,
  vertical_id_exclusions,
  earliest_activity_end,
  earliest_activity_start,
  latest_activity_end,
  latest_activity_start,
  company_uuids,
  companies,
  sort,
  address,
  include_matching_project_ids,
  exclude_matching_project_ids,
  point,
  radius,
}: Props) => {
  const filteredDocuments = useQuery(
    [
      'filteredDocuments',
      document_type_codes,
      state_code,
      city_id,
      city_ids,
      city_code,
      allowed_city_ids,
      mercator_metropolitan_id,
      mercator_metropolitan_ids,
      latest_status,
      keyword_inclusions,
      keyword_exclusions,
      vertical_id_inclusions,
      vertical_id_exclusions,
      earliest_activity_end,
      earliest_activity_start,
      latest_activity_end,
      latest_activity_start,
      company_uuids,
      companies,
      sort,
      address,
      include_matching_project_ids,
      exclude_matching_project_ids,
      point,
      radius,
      page,
    ],
    async (): Promise<DocumentDetailFilterResponse> => {
      const result = await ElasticSearchFilterAPI.postFilterDocuments({
        page,
        document_type_codes,
        state_code,
        city_id,
        city_ids,
        city_code,
        allowed_city_ids,
        mercator_metropolitan_id,
        mercator_metropolitan_ids,
        latest_status,
        keyword_inclusions,
        keyword_exclusions,
        vertical_id_inclusions,
        vertical_id_exclusions,
        earliest_activity_end,
        earliest_activity_start,
        latest_activity_end,
        latest_activity_start,
        company_uuids,
        companies,
        sort,
        address,
        include_matching_project_ids,
        exclude_matching_project_ids,
        point,
        radius,
      });

      return result?.data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  return {
    filteredDocuments,
  };
};
